module.exports = __webpack_public_path__ + "img/icon_menu.f9c23519.svg";